import { useFetchACHCompanies } from "../entities/achCompanies";
import { useFetchTemplates } from "../entities/fedwireTemplates/requests";
import { useFetchTemplates as useFetchSwiftWireTemplates } from "../entities/swiftwireTemplates/requests";
import { useFetchInstitution } from "../entities/institution/hooks";
import { useFetchUser } from "../entities/users/hooks";
import { useFetchRecipients } from "../entities/recipients/requests";
import { useFetchWireRecipients } from "../entities/wires";
import { useFetchAccounts } from "../entities/accounts";
import { useFetchAllUserAlerts } from "../entities/alerts";
import { useFetchDualApprovals } from "../entities/dualApprovals/requests";

import type { BootstrapRequestMap } from "./bootstrap.types";

const useFetchRecipientsIncludingHidden = () =>
  useFetchRecipients({ includeHidden: true });

export const requestHooks = {
  institution: useFetchInstitution,
  user: useFetchUser,
  fedwireTemplates: useFetchTemplates,
  swiftwireTemplates: useFetchSwiftWireTemplates,
  wireRecipients: useFetchWireRecipients,
  recipients: useFetchRecipients,
  recipientsIncludingHidden: useFetchRecipientsIncludingHidden,
  achCompanies: useFetchACHCompanies,
  accounts: useFetchAccounts,
  alerts: useFetchAllUserAlerts,
  dualApprovals: useFetchDualApprovals,
} satisfies BootstrapRequestMap;

export type RequestHooks = keyof typeof requestHooks;
